import React, { useState } from "react";
import styled from "styled-components";
import { Slider } from "primereact/slider";
import Textfield from "../textfield";
const StyledSlider = styled(Slider)`
	& .p-slider-handle {
		background-color: #ffffff !important;
		border: 2px solid #fecd08 !important;
	}
	.p-slider {
		background-color: #ffffff !important;
	}
`;
export default function SliderComponent({
	max = 1000,
	disabled = false,
	onChange,
	value = 50,
	name = "slider",
	min = 1,
}) {
	const [values, setValue] = useState(50);

	return (
		<div className="card flex justify-content-center">
			<div className="w-full">
				<Textfield
					disabled={disabled}
					value={value}
					onChange={(e) => {
						let regex = /^[0-9]+$/;
						if (
							parseInt(e.target.value) >= min &&
							parseInt(e.target.value) <= max &&
							regex.test(e.target.value)
						) {
							onChange(e);
							setValue(e.target.value);
						}
					}}
					className="w-full"
					name={name}
				/>
				<StyledSlider
					disabled={disabled}
					value={value}
					onChange={(e) => {
						setValue(e.value);
						onChange({ target: { name: name, value: e.value } });
					}}
					className="w-full"
					max={max}
					min={min}
					name={name}
				/>
			</div>
		</div>
	);
}
